import { func, object } from 'prop-types';
import React from 'react';
import { Form, Field } from 'react-final-form'
import { clientsActivityThresholdSettingsValidation } from '../../../models/operators/TenantSetttingsValidation';
import routePaths from '../../../routePaths';
import FormActions from '../../form/final-form/FormActions';
import FormTextField from '../../form/final-form/FormTextField';

const ClientsActivityThresholdSettingsForm = ({ onSubmit, initialValues }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={clientsActivityThresholdSettingsValidation}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <div>
          <Field
            name="clientsActivityThresholdDays"
            type="number"
            component={FormTextField}
            label="Próg aktywności w dniach"
            fullWidth
            parse={value => parseInt(value, 10)}
            format={value => value == null ? '' : value}
          />
        </div>

        <FormActions cancelRoutePath={routePaths.clientsReport} />
      </form>
    )}
  />
)

ClientsActivityThresholdSettingsForm.propTypes = {
  initialValues: object.isRequired,
  onSubmit: func.isRequired,
};

export default ClientsActivityThresholdSettingsForm;
